import {
  ERROR_MEETING_CANCELLED,
  ERROR_MEETING_EXPIRED,
  ERROR_MEETING_INVALID_CODE,
  ERROR_MEETING_NOT_OPEN,
  ERROR_MEETING_PRODUCT_UNAVAILABLE,
  ERROR_MEETING_WAITING_FOR_HOST,
} from "../Constants/constantValues";

export const meetingJoinErrorMessage = (error, t) => {
  if (error?.response?.status === 429) {
    return t("meeting_onboard.too_many_attempts");
  }

  switch (error?.response?.data?.error_code) {
    case ERROR_MEETING_INVALID_CODE:
      return t("meeting_onboard.invalid_meeting_id_or_code");
    case ERROR_MEETING_EXPIRED:
      return t("meeting_onboard.meeting_has_ended");
    case ERROR_MEETING_CANCELLED:
      return t("meeting_onboard.meeting_cancelled");
    case ERROR_MEETING_NOT_OPEN:
      return t("meeting_onboard.meeting_not_open_title");
    case ERROR_MEETING_WAITING_FOR_HOST:
      return t("meeting_onboard.waiting_for_host_title");
    case ERROR_MEETING_PRODUCT_UNAVAILABLE:
      return t("meeting_onboard.meeting_unavailable");
    default:
      return t("general.something_wrong");
  }
};
